import {
    createNavigationHooks,
    resolvePath,
    useRouteContext,
} from '@connected/core';

import { elektraConditions } from '@/config/conditions';
import { navigationRoutes, useNavigationContext } from '@/config/navigation-config';

// ============================================================================
// Re-export utilities from core package
// ============================================================================

export { resolvePath, useRouteContext };

// ============================================================================
// Conditions Hook for Navigation
// ============================================================================

/**
 * Hook that provides the conditions map for navigation filtering.
 * Used by createNavigationHooks to resolve named conditions.
 */
function useNavigationConditions() {
    return elektraConditions;
}

// ============================================================================
// Navigation Hooks (using generic factory from core package)
// ============================================================================

const navigationHooks = createNavigationHooks(
    useNavigationContext,
    navigationRoutes,
    useNavigationConditions,
);

/**
 * Returns filtered navigation routes based on context.
 * Supports both inline function conditions and named string conditions.
 */
export const useFilteredRoutes = navigationHooks.useFilteredRoutes;

/**
 * Returns only the top-level routes for sidebar display.
 */
export const useSidebarRoutes = navigationHooks.useSidebarRoutes;

/**
 * Returns ordered flat list of all visible LinkRoutes for prev/next traversal.
 */
export const useFlattenedRoutes = navigationHooks.useFlattenedRoutes;

/**
 * Returns ordered flat list of sidebar-only routes (top-level LinkRoutes).
 */
export const useFlattenedSidebarRoutes = navigationHooks.useFlattenedSidebarRoutes;

/**
 * Finds the parent LinkRoute that contains nested routes (tabs) for the current path.
 * Returns the nested routes if found, or null if not on a tabbed page.
 */
export const useHeaderNavigation = navigationHooks.useHeaderNavigation;

/**
 * Returns prev/next routes for current location.
 * Handles nested tab navigation with exitTo support.
 */
export const usePrevNextNavigation = navigationHooks.usePrevNextNavigation;
